<template>
    <div class="wrapper ">
        <div class="container-area ">
            <bannerTitle></bannerTitle>
            <img class="top-banner-picture" :src="require(`@/assets/TOP.jpg`)">
            <div class="row banner-date">
                <div class="col-sm-12 col-md-9">
                    <span style="font-size:9pt">NCU HAKKA COLLEGE E-PAPER 第{{ paperId }}期{{ publishedDate }} 出刊／ 半月刊</span>
                    <!-- 使用 HTML 字符實體 -->
                    <!-- <p style="font-family: 'Huninn';">Heart Symbol: &#178374; or &#x2B8C6; or &#131726; or &#x2028E; or &#25678; or &#x644E;</p> -->

                </div>
                <div class="col-sm-12 col-md-3">
                    <span>瀏覽人次：</span>
                   <a href="https://cn.web-counter.net" title="计数器"><img src="https://www.web-counter.net/count_20091204.php?c=0b9Qennj1Kw" style="border:0;padding:0;margin:0;" alt="计数器"></a><br/>
                </div>
            </div>
            <div class="row cover-content" v-for="(article, index) in articles" :key="index">
                <div class="col-sm-11 col-md-6 tl-left">
                    <img v-if="article.coverPicture" :src="require(`@/assets/${article.coverPicture}`)" class="img-block" alt="...">
                    <img v-else class="img-block" :src="require(`@/assets/BOT.jpg`)" alt="...">
                </div>

                <div class="col-sm-11 col-md-6 tl-left align-items-center d-flex">
                    <div>
                        <h6 class="cover-author">{{ article.coverAuthor }}</h6>
                        <h4 class="cover-title">{{ article.title }}</h4>
                        <div v-for="(content, index) in article.coverContent" :key="index">
                            <p class="cover-text">{{ content }}</p>
                        </div>
                        <router-link :to="`${paperId}-${index + 1}`" class="continue-reading">繼續閱讀</router-link>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <br>
            <homeBottom></homeBottom>
            <bannerBottom></bannerBottom>
        </div>
    </div>
</template>
<style>
/* @font-face {
    font-family: 'Huninn';
    src: url('../fonts/jf-openhuninn-2.0.ttf') format("truetype");
} */
@font-face {
    font-family: 'GenSeki';
    src: url('../fonts/GenSekiGothicJP-M-02.ttf') format("truetype");
}

.top-banner-picture {
    width: 100%;
    height: auto;
    display: block;
}

.banner-date {
    font-size: 9pt;
    background-color: black;
    color: white;
    padding: 20px;
    margin: 0px 0px 40px 0px;
}

.container-area {
    max-width: 800px;
    margin: 0 auto;
    background-color: white;
    text-align: center;
    position: relative;
    z-index: 10;
}

.img-block {
    width: 280px;
    height: 280px;
    overflow: hidden;
    border-radius: 2%;
    object-fit: cover;
}

.continue-reading {
    color: #fff;
    text-decoration: none;
    font-weight: 600;
    display: inline-block;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 26px;
    background: #be369b;
    border: 2px solid#be369b;
    text-transform: capitalize;
    margin: 20px 0px 0px;
}

.tl-left {
    text-align: left;
}

.cover-author {
    color: #be369b;
    font-size: 13px;
    letter-spacing: 1px;
    margin-bottom: 6px;
}

.cover-title {
    color: #1c1918;
    font-size: 18px;
    font-weight: bold;
    line-height: 28px;
    text-transform: capitalize;
}

.cover-text {
    /* margin: 10px 0 20px 0; */
    margin: 0px;
    font-size: 15px;
    color: #777;
    line-height: 26px;
}

.cover-content {
    margin: 17px 30px!important;
}
</style>
<script>
import bannerTitle from '@/components/banner.vue'
import homeBottom from '@/components/homeBottom.vue'
import bannerBottom from '@/components/bannerBottom.vue'
import {parsingFunctionMixin} from '@/components/parsingFunction.js'
export default {
    name: 'App',
    components: {
        bannerTitle,
        homeBottom,
        bannerBottom
    },
    mixins: [parsingFunctionMixin],
   
    data() {
        return {
            paperId: '459',
            publishedDate: '2024/12/21',
        }
    },


}
</script>
  

